import clientOverviewStub from "stubs/clientOverview";
import { displayAmountWithCurrency, removeFalseyArrayItems } from "utils";
import { booleanToText } from "utils";
import {
  INTEREST_SERVICE_LEVEL_FULL_LABEL,
  INTEREST_SERVICE_LEVEL_SPECIFIED_LABEL,
  INTEREST_SERVICE_VALID_PERCENTAGES,
  PRODUCT_TYPE_ROLLUP,
  PRODUCT_TYPE_INTEREST_SERVICE,
} from "lib/constants";
import {
  productTypeLabelResolver,
  interestServicingPercentageResolver,
} from "resolvers";

const loanPanelResolver = (loanData) => {
  return {
    ...clientOverviewStub.panels.loan,
    details: removeFalseyArrayItems([
      {
        label: "Initial advance",
        value: loanData?.loan_amount_maximum
          ? "Maximum"
          : displayAmountWithCurrency(loanData?.loan_amount),
        incomplete: !loanData,
      },
      {
        label: "Product type",
        value: productTypeLabelResolver(loanData?.product_type),
      },
      loanData?.product_type === PRODUCT_TYPE_INTEREST_SERVICE && {
        label: "Interest servicing level",
        value:
          loanData?.interest_servicing_percentage == null
            ? ""
            : loanData?.interest_servicing_percentage <
              INTEREST_SERVICE_VALID_PERCENTAGES[100]
            ? INTEREST_SERVICE_LEVEL_SPECIFIED_LABEL
            : INTEREST_SERVICE_LEVEL_FULL_LABEL,
      },
      loanData?.product_type === PRODUCT_TYPE_INTEREST_SERVICE && {
        label: "Interest service percentage",
        value: loanData?.interest_servicing_percentage
          ? `${interestServicingPercentageResolver(
              loanData.interest_servicing_percentage
            )}%`
          : undefined,
      },
      (loanData?.product_type === PRODUCT_TYPE_ROLLUP ||
        loanData?.product_type === undefined) && {
        label: "Cash reserve",
        value: loanData
          ? booleanToText(loanData.use_cash_reserve_feature)
          : undefined,
        incomplete: !loanData,
      },
      loanData?.use_cash_reserve_feature && {
        label: "Reserve required",
        value: loanData.cash_reserve_maximum
          ? "Maximum"
          : displayAmountWithCurrency(loanData.cash_reserve),
      },
    ]),
  };
};

export default loanPanelResolver;
